var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-no-wrap"},[_c('v-avatar',_vm._b({staticClass:"mr-2",attrs:{"size":"12"}},'v-avatar',_vm.attrs,false)),_c('span',[_vm._v(_vm._s(_vm.state))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }